<div class="flex flex-col flex-auto w-full">
    <!-- Title -->
    <!---->
    <div class="mt-1 mb-2 mx-6 text-4xl font-extrabold tracking-tight leading-none"></div>

    <!-- Navigation -->
    <fuse-vertical-navigation
        [navigation]="menuData"
        [inner]="true"
        [mode]="'side'"
        [opened]="true">
    </fuse-vertical-navigation>
   
    <!-- Storage -->
    <!-- <div class="mx-6">
        <div class="flex items-center">
            <mat-icon
                class="mr-2 icon-size-5"
                [svgIcon]="'heroicons_solid:circle-stack'"></mat-icon>
            <div class="text-lg font-semibold">Storage</div>
        </div>
        <div class="flex flex-col flex-auto mt-4">
            <span class="text-sm leading-none mb-3">{{storage.storageSize}} GB of {{storage.storageThreshold}} GB used</span>
            <mat-progress-bar
                [mode]="'determinate'"
                [color]="'primary'"
                
                [value]="storagePercentage"></mat-progress-bar>
        </div>
    </div> -->
    <!--TODO - navigate to dedicated view to purchase additional storage-->
    <!-- <button
        class="mx-4 mt-4 mb-4"
        mat-stroked-button
        aria-label="increase storage capacity"
        [color]="'primary'"
        [routerLink]="['/apps/settings/payment']"
        >
        <mat-icon svgIcon="mat_outline:storage"></mat-icon>
        <span class="ml-2">Get More</span>
    </button> -->

</div>
